<template>
  <div>
    <b-row>
      <b-col>
        <strong>{{ buildingLot.building_owner_has_building_lot_id }}</strong>
        <strong>{{ buildingLot.name }}</strong>
      </b-col>
      <b-col>
        <b-row class="justify-content-center">
          <b-col>
            <label>{{ $t("general.droit_de_votes") }}</label>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col class="d-inline-flex justify-content-center align-items-end">
            <div class="custom-select-autocomplete w-100">
              <b-input
                ref="v-input"
                class="custom-select-autocomplete-input"
                autocomplete="off"
                :value="defaultVotingCategory.name"
                @input="input($event)"
                @focus="focus($event)"
                @blur="blur($event)"
              />
              <v-select
                :key="vSelectKey"
                ref="v-select"
                class="custom-select-autocomplete-select"
                :reduce="name => name.id"
                :options="unattachedVotingCategories"
                label="name"
                @input="select($event)"
              >
                <span slot="no-options">
                  {{ $t("general.select_with_input_no_option") }}
                </span>
              </v-select>
            </div>
            <b-button
              :disabled="defaultVotingCategory.name.length == 0"
              class="button btn-blue ml-1"
              @click="CREATE_VOTING_CATEGORY"
            >
              <font-awesome-icon icon="plus" />
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div v-for="(votingRight, index) in allBuildingOwnerVotingRights" :key="index">
      <appVotingRight
        :voting-right="votingRight"
        :voting-categories="allVotingCategories"
        @deleteVotingRight="deleteVotingRight"
        @updateVotingRight="updateVotingRight"
      />
    </div>
  </div>
</template>

<script>
import appVotingRight from "./Step3VotingRight";
var uuid = require("uuid");

export default {
  components: {
    appVotingRight,
  },
  props: {
    buildingLot: {
      type: Object,
      default: () => {
        return {};
      },
    },
    buildingId: {
      type: String,
      default: "",
    },
    votingCategories: {
      type: Array,
      default: () => {
        return [];
      },
    },
    buildingOwner: {
      type: Object,
      default: () => {
        return {};
      },
    },
    buildingOwnerVotingRights: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      defaultVotingCategory: {
        agency_id: Number(localStorage.getItem("agencyId")),
        name: "",
        building_id: this.buildingId,
      },
      buildingOwnerHasVotingRights: [],
      propBuildingOwnerHasVotingRights: [],
      allVotingCategories: [],
      vSelectKey: 0,
    };
  },
  computed: {
    allBuildingOwnerVotingRights() {
      let filteredResults = [];
      this.$_.each(this.propBuildingOwnerHasVotingRights, votingRight => {
        this.$_.each(this.buildingLot.building_owner_building_lots, bOwnerBLot => {
          if (votingRight.building_owner_has_building_lot_id == bOwnerBLot.id) {
            filteredResults.push(votingRight);
          }
        });
      });
      return filteredResults;
    },
    // NOTE: get in options only the values that are not attributed yet
    unattachedVotingCategories() {
      var self = this;
      var votingCategories = JSON.parse(JSON.stringify(this.allVotingCategories));
      const result = self.$_.reject(votingCategories, function (votingCategory) {
        return self.$_.find(self.allBuildingOwnerVotingRights, function (item) {
          return item.voting_category_id == votingCategory.id;
        });
      });
      return this.$_.sortBy(result, item => {
        return item.name;
      });
    },
  },
  created() {
    this.propBuildingOwnerHasVotingRights = this.buildingOwnerVotingRights;
    if (this.buildingOwner.voting_categories) {
      this.allVotingCategories = this.buildingOwner.voting_categories;
    } else {
      this.allVotingCategories = this.votingCategories;
    }
  },
  methods: {
    updateBuildingOwner(key, value) {
      this.$emit("updateBuildingOwner", key, value);
    },
    // input + select + autocomplete functions
    input(e) {
      this.defaultVotingCategory.name = e;
      this.$refs["v-select"].search = e;
    },
    focus(e) {
      this.$refs["v-select"].open = true;
    },
    blur(e) {
      this.$refs["v-select"].open = false;
    },
    select(e) {
      this.propBuildingOwnerHasVotingRights.push({
        id: uuid.v4(),
        building_owner_has_building_lot_id: this.buildingLot.building_owner_building_lots[0].id,
        voting_category_id: e,
        parts: 0,
      });
      this.updateBuildingOwner(
        "building_owner_has_voting_rights",
        this.propBuildingOwnerHasVotingRights
      );
      this.$nextTick(() => {
        this.$refs["v-input"].blur();
      });
    },
    CREATE_VOTING_CATEGORY() {
      let votingCategoryId = uuid.v4();
      this.allVotingCategories.push({
        id: votingCategoryId,
        name: this.defaultVotingCategory.name,
        is_charge_general: 0,
      });
      this.propBuildingOwnerHasVotingRights.push({
        id: uuid.v4(),
        building_owner_has_building_lot_id: this.buildingLot.building_owner_building_lots[0].id,
        voting_category_id: votingCategoryId,
        parts: 0,
      });
      this.updateBuildingOwner(
        "building_owner_has_voting_rights",
        this.propBuildingOwnerHasVotingRights
      );
      this.updateBuildingOwner("voting_categories", this.allVotingCategories);
      this.$nextTick(() => {
        this.$refs["v-input"].blur();
        this.defaultVotingCategory.name = "";
        this.$refs["v-select"].search = "";
      });
    },
    deleteVotingRight(votingRight) {
      let indexToBeDeleted = this.$_.findIndex(this.propBuildingOwnerHasVotingRights, item => {
        return item.id == votingRight.id;
      });
      if (votingRight.agency_id) {
        this.propBuildingOwnerHasVotingRights.splice(indexToBeDeleted, 1);
        this.propBuildingOwnerHasVotingRights.splice(indexToBeDeleted, 0, {
          id: votingRight.id,
          isDeleted: true,
        });
      } else {
        if (indexToBeDeleted != -1) {
          this.propBuildingOwnerHasVotingRights.splice(indexToBeDeleted, 1);
        }
      }

      this.forceRerenderVSelect();
    },
    updateVotingRight(votingRight, key, value) {
      let indexToBeUpdated = this.$_.findIndex(this.propBuildingOwnerHasVotingRights, item => {
        return item.id == votingRight.id;
      });
      if (indexToBeUpdated != -1) {
        this.propBuildingOwnerHasVotingRights[indexToBeUpdated][key] = value;
      }
    },
    forceRerenderVSelect() {
      this.vSelectKey++;
    },
  },
};
</script>
